import { useTranslation } from "react-i18next";
import { Component } from "react";

export function Beginnings() {
    const { t } = useTranslation();

    return(
        <div className="beginnings box">
            <h2>{ t("Beginnings are always difficult") }</h2>
            <div className="message margin-bottom-small">
                { t("Do not hesitate to contact us with any questions you may have.") }
            </div>
            <div className="actions">
                <a className="btn btn-primary" href="mailto:taskgenproject@gmail.com">
                    { t("Contact us") }
                </a>
            </div>
        </div>
    );
}